import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Select from 'components/Forms/Fields/Select';
import TextArea from 'components/Forms/Fields/TextArea';
import Button from 'components/Button';

import styles from './index.module.scss';
import isEmpty from 'lodash/isEmpty';

const EventPopupForm = ({ submit }) => {
  const [formFields, setFormFields] = useState({
    reason: '',
    description: '',
  });
  const [error, setError] = useState();
  const options = [
    {
      name: 'Spam',
      id: 'SPAM',
    },
    {
      name: 'Inappropriate content',
      id: 'OFFENSIVE',
    },
    {
      name: 'Privacy Issue',
      id: 'PRIVACY_VIOLATION',
    },
    {
      name: 'Copyright Issue',
      id: 'COPYRIGHT_VIOLATION',
    },
    {
      name: 'Incorrect Information',
      id: 'INACCURATE',
    },
    {
      name: 'Some other reason',
      id: 'OTHER',
    },
  ];

  const onChangeFormField = e => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    setFormFields({ ...formFields, [fieldName]: fieldValue });
  };

  const submitHandler = () => {
    if (formFields.description === '' && formFields.reason === 'OTHER') {
      setError('required');
      return;
    }
    submit(formFields);
  };

  return (
    <form className={styles.form}>
      <Select
        label={'Reason'}
        name={'reason'}
        options={options}
        onChange={onChangeFormField}
        required={true}
        value={formFields.reason}
      />
      <TextArea
        label={'Description'}
        field={'description'}
        onChange={onChangeFormField}
        placeholder="Enter more details"
        maxLength={250}
        required={formFields.reason === 'OTHER'}
        displayError={isEmpty(error)}
        error={error}
      />
      <div className={styles.btnContainer}>
        <Button
          type="button"
          text={'Confirm'}
          onClick={submitHandler}
          size="l"
          disabled={formFields.reason === ''}
        />
      </div>
    </form>
  );
};

EventPopupForm.propTypes = {
  submit: PropTypes.func,
};

export default EventPopupForm;
